<template>
  <div class="image-seo-wrapper">
    <img v-if="typeof item[type] !== 'undefined'" :src="item[type].data.find(el => el.type === typeImage).src"
         :alt="item[type].data.hasOwnProperty('seo') ?
       item[type].data.seo.data.hasOwnProperty('alterText') ?
       item[type].data.seo.data.alterText : '' : ''"
         :title="item[type].data.hasOwnProperty('seo') ?
       item[type].data.seo.data.hasOwnProperty('title') ?
       item[type].data.seo.data.title : '' : ''">
    <img v-else :src="item.image.data.src">
  </div>
</template>
<script>
export default {
  name: 'image-seo',
  props: {
    item: {},
    type: {
      type: String,
      default: 'images'
    },
    typeImage: {
      type: String,
      default: 'default'
    }
  }
}
</script>

<style lang="scss" scoped>
.image-seo-wrapper {
  width: 100%;
  height: 100%;
}
</style>
